import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { useAuthLogoutMutation } from '../../common/redux/api/web-api'
import { requestPortalSessionReset } from '../../common/redux/features/portal-session-reset/portalSessionResetSlice'
import { triggerAuthChange } from '../../common/utils/broadcastChannel'
import storage from '../../common/utils/storage'
import { isPartnerDomain, isPortalDomain } from '../currentDomain'

const applyLocalSignOutSideEffects = ({
    showNotificationMessage = true,
}: { showNotificationMessage?: boolean } = {}) => {
    if (isPartnerDomain) storage.removeItem('iw_state')

    showNotificationMessage && storage.setItem('notification', { text: 'lblSignedOutMessage', type: 'notice' })
}

type LogoutRequest = {
    unwrap: () => Promise<unknown>
}

export const useSignOut = ({ showNotificationMessage = true }: { showNotificationMessage?: boolean } = {}) => {
    const dispatch = useDispatch()
    const [logout] = useAuthLogoutMutation()

    return useCallback(() => {
        const logoutRequest: LogoutRequest | null = isPortalDomain ? logout() : null

        applyLocalSignOutSideEffects({ showNotificationMessage })

        void Promise.resolve(logoutRequest?.unwrap())
            .catch(() => {
                // Clear local session state even if backend logout fails or the session is already gone.
            })
            .finally(() => {
                dispatch(requestPortalSessionReset())
                triggerAuthChange()
            })
    }, [dispatch, logout, showNotificationMessage])
}
